import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const DEFAULTS = {
  profesion: "psicologia",
  profesional_titulo: "Lic.",
  profesional_nombre: "Nombre Apellido",
  consultorio_nombre: "Consultorio Demo",
  consultorio_direccion: "",
  consultorio_gmaps_url: "",
  horarios_texto: "Lunes a Sábados de 10:00 a 20:00 hs",
  sesiones_totales: 8,
  test_inicial_nombre: "ORIGEN",
  termino_paciente_singular: "paciente",
  termino_paciente_plural: "pacientes",
  termino_sesion: "sesión",
  moneda: "PYG",
  pais: "Paraguay",
  codigo_pais_whatsapp: "595",
};

const ConfigContext = createContext(DEFAULTS);

export const ConfigProvider = ({ children }) => {
  const { user } = useAuth();
  const [config, setConfig] = useState(DEFAULTS);

  useEffect(() => {
    if (!user || user === false) return;
    api
      .get("/config")
      .then(({ data }) => setConfig({ ...DEFAULTS, ...data }))
      .catch((err) => {
        console.warn("No se pudo cargar la configuración, usando defaults:", err);
        setConfig(DEFAULTS);
      });
  }, [user]);

  const refresh = async () => {
    try {
      const { data } = await api.get("/config");
      setConfig({ ...DEFAULTS, ...data });
    } catch (err) {
      console.warn("No se pudo refrescar la configuración:", err);
    }
  };

  return <ConfigContext.Provider value={{ ...config, refresh }}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => useContext(ConfigContext);
